import { Home } from "../../components";

export default function HomePage() {
    return (
        <div>
            <Home />
        </div>
    )
}